import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { localRunnerCommand } from "@/lib/connect-token";

export function LocalRunnerCommand({ connectToken }: { connectToken: string }) {
  const [copied, setCopied] = useState(false);
  const command = localRunnerCommand(connectToken);

  const handleCopy = () => {
    navigator.clipboard.writeText(command);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="group relative" style={{ maxWidth: 0, minWidth: "100%" }}>
      <div className="overflow-x-auto rounded-lg bg-muted px-3 py-2.5 pr-8">
        <code className="whitespace-nowrap font-mono text-xs leading-relaxed text-foreground">
          {command}
        </code>
      </div>
      <button
        type="button"
        onClick={handleCopy}
        className="absolute right-2 top-2 rounded-md bg-background/80 p-1 text-muted-foreground opacity-0 transition-opacity hover:text-foreground group-hover:opacity-100"
        aria-label="Copy command"
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-finding-helps" />
        ) : (
          <Copy className="h-3.5 w-3.5" />
        )}
      </button>
    </div>
  );
}
